import React from "react";
import "./CoursePage.css";
import OLevelBanner from "../Component/IMG-20251113-WA0040.jpg";

const OLevelPage = () => {
  return (
    <div className="course-page">
      {/* Banner Section */}
      <div className="course-banner">
        <img src={OLevelBanner} alt="O Level" className="banner-img" />
      </div>

      {/* Content Section */}
      <div className="course-content">
        <h2>O Level – Foundation in Computer Applications</h2>

        <p className="course-text">
          The <strong>O Level</strong> course, recognized by NIELIT, provides a
          strong foundation in IT and computer applications. It focuses on
          programming, web development, and office automation skills essential
          for entry-level IT professionals.
        </p>

        <p className="course-text">
          At <strong>CPIT</strong>, students receive practical training and
          certification that helps them start a professional IT career or
          continue with higher-level courses like ‘A Level’.
        </p>

        <p className="course-text">
          The course modules include IT Tools, Business Systems, Internet
          Technologies, and Programming in C. Students also gain hands-on
          experience in HTML, CSS, and database connectivity.
        </p>

        <p className="course-text">
          This structured program ensures that every learner understands both
          software and hardware fundamentals, empowering them for diverse IT
          roles in private and government sectors.
        </p>

        <p className="course-text">
          CPIT’s expert faculty emphasizes skill-based training and regular
          assessments to help students achieve certification success and
          professional readiness.
        </p>

        <p className="course-text mb-0">
          The O Level program by CPIT opens doors to exciting careers in IT,
          data management, and software development while building a lifelong
          foundation in computer technology.
        </p>
      </div>
    </div>
  );
};

export default OLevelPage;
